<template>
  <Modal ref="baseModal">
    <div class="modal-inner">
      <div class="modal-body">
        <h3>담당 기관 정보</h3>
        <p class="mt-sm">
          본 강의는 <span class="blue">비수도권 소재 담당 교육기관에서 진행</span>됩니다.<br/>
          강의에 대한 문의사항은 아래 기관 연락처로 문의 바랍니다.<br/>
        </p>
        <div class="table-form">
          <table class="vertical">
            <colgroup>
              <col width="30%">
              <col />
            </colgroup>
            <tr>
              <th>담당 기관명</th>
              <td v-if="partnerInfo">{{ partnerInfo.partnerName }}</td>
            </tr>
            <tr>
              <th>연락처</th>
              <td v-if="partnerInfo">{{ partnerInfo.partnerPhoneNum }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <KSAPrimaryButton class="full-btn" text="확인" @click="close" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {onMounted, ref} from "vue";
import lectureUserService from "@/pages/user/services/lecture/lectureUserService";

export default {
  name: "ConfirmModal",
  components: {
    Modal,
  },
  setup() {
    const baseModal = ref(null);
    const resolvePromise = ref(null);
    const partnerId = ref(null);
    const partnerInfo = ref(null);

    const show = () => {
      baseModal.value.open();

      return new Promise((resolve, _) => {
        // resolve 함수를 담아 외부에서 사용합니다.
        resolvePromise.value = resolve;
      });
    };

    const close = () => {
      baseModal.value.close();
      resolvePromise.value(true);
    };

    const init = (id) => {
      partnerId.value = id;
      retrievePartnerInfo(id);
    };

    const retrievePartnerInfo = (partnerId) => {
      lectureUserService.retrievePartner(partnerId)
        .then((res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            partnerInfo.value = result;
          }
        })
        .catch( (error) =>  {
          loadingStore.loading = false;
          console.log(error);
        });
    }

    return { baseModal, show, close, init, partnerId, retrievePartnerInfo, partnerInfo };
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

</style>